import useCurrentHcs from '../../../hooks/useCurrentHcs'
import PlannedExpertiseCardList from '../plannedExpertiseCard/PlannedExpertiseCardList'
import { PlannedExpertiseMainProps } from './_props'

const PlannedExpertiseMain = ({ isPreview }: PlannedExpertiseMainProps) => {
    const currentHcs = useCurrentHcs()

    return (
        <div key={'expertise-' + currentHcs.id}>
            <PlannedExpertiseCardList isPreview={isPreview} />
        </div>
    )
}

export default PlannedExpertiseMain
